/* eslint-disable no-unused-vars */
import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';
import Login from '../pages/auth/login';
import AuthService from '../services/authService';
import Callback from '../pages/auth/callback';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../pages/auth/authSlice';
import { RouteList } from './routesList';
import CookieClearPage from '../pages/cookieClearPage';
import ChunkLoadErrorBoundary from '../components/chunk-error-boundary';
import Spinners from '../components/spinner';

const RoutesContainer = () => {
  const authService = new AuthService();
  const currentHash = window.location.hash;
  const isAuthenticated = useSelector(selectIsAuthenticated) || authService.isAuthenticated();

  return (
    <ChunkLoadErrorBoundary>
      <Suspense fallback={<Spinners containerClassName='h-screen' />}>
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/redirect' element={<CookieClearPage />} />
          <Route path='/callback' element={<Callback />} />
          <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
            {RouteList.map((route, i) => (
              <Route path={route.path} element={<route.component />} key={i} />
            ))}
            <Route path='/' element={<Navigate to={`/check-user${currentHash}`} replace />} />
            <Route path='*' element={<Navigate to='/page-not-found' replace />} />
          </Route>
        </Routes>
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};

export default RoutesContainer;
